import Celebration from './Celebration';

class FirstDay extends Celebration {}

export default FirstDay;
